import { Selector } from '@ngxs/store';
import { get as _get } from 'lodash';
import { OfferListQuery } from '../interfaces/offer-list.query';
import { Configuration, ConfigurationState, InventoryItem, OffersState, OffersStateModel, SellerOfferDto, DateUtilsService, DetailsState, DateTimeFormat } from 'remarketing-angular-library';
import { OfferHistory, PreviousOffers } from '../components/history/history.component';

export class OffersQueries {
  static dateUtilService: DateUtilsService;
  @Selector([OffersState, DetailsState.inventoryItem, ConfigurationState.configuration])
  static offerList(
    state: OffersStateModel,
    inventoryItem: InventoryItem,
    configuration: Configuration
  ): OfferListQuery {
    const { offers, loading, hasError } = state;
    let requestState;
    if (loading) {
      requestState = 'LOADING';
    } else if (hasError) {
      requestState = 'ERROR';
    } else if (offers.length === 0) {
      requestState = 'NO_RESULTS';
    } else {
      requestState = 'LOADED';
    }

    return {
      requestState,
      offers,
      inventoryItem,
      tenantName: configuration.tenantName || ''
    };
  }

  @Selector([OffersState.offers, OffersState.history])
  static history(offers: SellerOfferDto[], history: { [offerUuid: string]: SellerOfferDto[] }) {
    const fn = (offerUuid: string) => {
      const rootOffer = offers.find(o => o.offerUuid === offerUuid);
      const previousOffers: SellerOfferDto[] = _get(history, offerUuid, []);
      return rootOffer
        ? OffersQueries.mapOffersToOfferHistory(rootOffer, previousOffers)
        : { offer: undefined, previousOffers: { offersByDate: {}, dates: [] } };
    };

    return fn;
  }

  private static mapOffersToOfferHistory(rootOffer: SellerOfferDto, offerChain: SellerOfferDto[]): OfferHistory {
    function compareOffers(o1: SellerOfferDto, o2: SellerOfferDto) {
      return Date.parse(o1.offerDate) < Date.parse(o2.offerDate) ? -1 : 1;
    }

    function reduceToPreviousOffers(carry: PreviousOffers, offer: SellerOfferDto): PreviousOffers {
      const d = new Date(offer.offerDate);
      const date = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
      if (!carry.offersByDate[date]) {
        carry.offersByDate = { ...carry.offersByDate, [date]: [] };
        carry.dates = [...carry.dates, date];
      }
      carry.offersByDate[date] = [...carry.offersByDate[date], offer];

      return carry;
    }

    /*
      Sort first because Date.toLocaleString() strips the microtime which affects offers that are counted by the seller.
      When a seller counters, a decline and then counter event are created fairly close to eachother (within a second)
      which can cause issues when sorting.
     */
    const previousOffers = [...offerChain]
      .sort(compareOffers)
      .map(o => {
        let offerDate: any;
        // Catch errors if browser doesn't support timezones.
        try {
          offerDate = this.dateUtilService.formatDate(o.offerDate, DateTimeFormat.H_MM_A, true)
        } catch (e) {
          offerDate = o.offerDate;
        }
        return {
          ...o,
          offerDate
        };
      })
      .reduceRight(reduceToPreviousOffers, { dates: [], offersByDate: {} });

    return {
      offer: rootOffer,
      previousOffers
    };
  }
}
